export default __webpack_public_path__ + "fonts/overview_2.d1e91db8904ded34e526fa6fb8dc63fe.png";